import { EditOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';

import styles from './RequestJobPostingHistory.module.css';

interface RequestJobPostingEditTimelineTimelineProps {
  userName: string;
  changedFields: Record<string, string | number>;
  createdDate: string;
}

const RequestJobPostingEditTimeline = ({
  userName,
  changedFields,
  createdDate,
}: RequestJobPostingEditTimelineTimelineProps) => {
  const orderedFields = [
    'type',
    'employee_name_being_replaced',
    'positions',
    'name',
    'start_salary',
    'end_salary',
    'branch',
    'company',
    'affiliate',
    'unit_business',
    'job_role',
    'department',
  ];

  const changedFieldsName = {
    type: 'Tipo de requisição',
    name: 'Nome da requisição',
    employee_name_being_replaced: 'Nome do substituído',
    positions: 'Posições',
    start_salary: 'Início da faixa salarial',
    end_salary: 'Fim da faixa salarial',
    branch: 'Unidade',
    company: 'Empresa',
    job_role: 'Cargo',
    department: 'Departamento',
    affiliate: 'Afiliada',
    unit_business: 'Unidade de negócio',
  };

  const requestTypeDict = {
    STAFF_INCREASE: 'Aumento de Quadro',
    SUBSTITUTION: 'Substituição',
  };

  return (
    <Timeline.Item dot={<EditOutlined className={styles.editedColor} />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{userName} </Typography.Text>
            editou a requisição
          </Typography.Text>
          <br />
          {orderedFields.map((field) => {
            if (field in changedFields) {
              const adjustedValue =
                field === 'type'
                  ? requestTypeDict[changedFields[field] as 'STAFF_INCREASE' | 'SUBSTITUTION']
                  : changedFields[field];

              return (
                <>
                  <br />
                  {
                    changedFieldsName[
                      field as
                        | 'type'
                        | 'name'
                        | 'employee_name_being_replaced'
                        | 'positions'
                        | 'start_salary'
                        | 'end_salary'
                        | 'branch'
                        | 'company'
                        | 'job_role'
                        | 'department'
                        | 'affiliate'
                        | 'unit_business'
                    ]
                  }
                  : {adjustedValue}
                </>
              );
            }
          })}
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default RequestJobPostingEditTimeline;
